import React from 'react';
import { FaChartLine, FaChartPie, FaChartBar } from 'react-icons/fa';

const ChartTypeSelector = ({ selectedType, onSelect }) => {
  return (
    <div className="chart-type-selector">
      <button
        type="button"
        className={`chart-type-button ${selectedType === 'line' ? 'active' : ''}`}
        title="Gráfico de línea"
        onClick={() => onSelect('line')}
      >
        <FaChartLine size={16} />
      </button>
      <button
        type="button"
        className={`chart-type-button ${selectedType === 'bar' ? 'active' : ''}`}
        title="Gráfico de barras"
        onClick={() => onSelect('bar')}
      >
        <FaChartBar size={16} />
      </button>
    </div>
  );
};

export default ChartTypeSelector;
